export default "images/camera-bg.jpg";